import React from 'react';
import { stats } from '../../data/content';
export function Stats() {
  return <section className="w-full border-y border-navy/10 bg-white px-4 py-8" aria-label="Resultados" data-id="element-211" data-mp="2fgggcrp3dspg">
      <div className="mx-auto grid max-w-3xl grid-cols-2 gap-y-6 sm:grid-cols-4" data-id="element-212" data-mp="2agu34i99kcgn">
        {stats.map(s => <div key={s.label} className="px-2 text-center" data-id="element-213" data-mp="26g1rjicx5vh7">
            <p className="font-display text-3xl font-black tracking-tight text-navy sm:text-4xl" data-id="element-214" data-mp="26dfdczviwhq0">
              {s.value}
            </p>
            <p className="mx-auto mt-1 max-w-[150px] text-[11px] font-semibold uppercase leading-snug tracking-wide text-navy/50" data-id="element-215" data-mp="2y66cpj8i6mjh">
              {s.label}
            </p>
          </div>)}
      </div>
    </section>;
}